import { fromZodError } from 'zod-validation-error';

import type { ZodError } from 'zod';

// @deprecated use convertZodErrorsIntoMap instead
export const zodErrorConverter = (error: ZodError) => {
  return fromZodError(error).details;
};
